import PlaceholderPage from "../../../components/Placeholder/PlaceholderPage";

const SettingsPage = () => (
  <PlaceholderPage
    title="Settings"
    description="Vendor manager settings will appear here."
  />
);

export default SettingsPage;
